"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NativeToolbarSearchBarSlot", {
    enumerable: true,
    get: function() {
        return NativeToolbarSearchBarSlot;
    }
});
const NativeToolbarSearchBarSlot = ()=>null;

//# sourceMappingURL=native.js.map
